import { CircleAlert } from "lucide-react";
import { Badge } from "../ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export function ExpiredMemberBadge({ variant }: { variant: keyof typeof TEXTS }) {
    return (
        <Tooltip>
            <TooltipTrigger className="w-fit">
                <Badge variant="destructive">
                    <CircleAlert />
                    {TEXTS[variant].badgeText}
                </Badge>
            </TooltipTrigger>
            <TooltipContent>{TEXTS[variant].tooltipText}</TooltipContent>
        </Tooltip>
    );
}

const TEXTS = {
    membershipExpired: {
        badgeText: "Membership expired, no new requests",
        tooltipText:
            "The member’s membership has expired. Service existing requests, but do not accept new ones until they have reconfirmed.",
    },
    eligibilityExpired: {
        badgeText: "Eligibility expired, no new requests",
        tooltipText:
            "The member’s eligibility has expired. Service existing requests, but do not accept new ones until they have reconfirmed.",
    },
} as const;
